import * as Yup from "yup";

export interface ErrorType {
  path: string;
  message: string;
}

export default async function validate(
  data: unknown,
  schema: Yup.AnyObjectSchema,
  contextOption?: Record<string, unknown>
): Promise<[boolean, ErrorType[]]> {
  let isValid = true;
  let invalidFields: ErrorType[] = [];

  try {
    await schema.validate(data, { abortEarly: false, context: contextOption });
  } catch (error: unknown) {
    if (error instanceof Yup.ValidationError) {
      if (error.name !== "ValidationError") {
        throw error;
      }
      isValid = false;
      invalidFields = error.inner.reduce((acc: ErrorType[], curr) => {
        if (curr.path) {
          acc.push({ path: curr.path, message: curr.message });
        }
        return acc;
      }, []);
    }
  }
  return [isValid, invalidFields];
}
